import { render, staticRenderFns } from "./DaerahTanpaAksesCOD.html?vue&type=template&id=b1264bfc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./DaerahTanpaAksesCOD.scss?vue&type=style&index=0&id=b1264bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1264bfc",
  null
  
)

export default component.exports